export const profileImageUrl = (employee) => {
    if (employee?.avatar && employee?.avatar !== '0') {
        return employee?.avatar;
    }
    return '/img/user_empty.png';
}
